
import validateProperty from './validate_property.js';

export default function validateLayoutProperty(options) {
    return validateProperty(options, 'layout');
}
